import ContentConfig from '../config/ContentConfig';
import Locality from '../locality/Locality';
import { ContentCallInfo } from '../common/utils/contentUrls';
import { DurationTimer, LocalitySetup } from '../common/utils/duration';
import { ElevenAgentData } from '../ecdn11/interfaces';
import { IceCandidateStructure } from '../locality/interfaces';
import { NetworkData } from '../locality/networkDataStorage';
import { PingData } from '../locality/probeUrls';
import { GetIceCandidatesFunction } from '@kollective-frontend/ksdk-api';

export interface AgentInput {
  chunk: LocalitySetup;
  config: ContentConfig;
  eleven?: ElevenAgentData;
  ics?: IceCandidateStructure;
  primingData: PrimingDataInput;
  probe?: PingData;
}

export interface PrimingData {
  ecdn11?: ElevenAgentData;
  ics: IceCandidateStructure;
  locality: Locality;
  networkData?: NetworkData;
}

export interface MaybePrimingDataInput {
  config: ContentConfig;
  contentHost: string;
  info: ContentCallInfo;
  iceCandidates?: PossibleIceCandidate[];
  getIceCandidates?: GetIceCandidatesFunction;
  eventTitle?: string;
  playGuid: string;
  startTime: number;
  userEmail?: string;
  timeout?: number;
}

export type PossibleIceCandidate =
  | RTCIceCandidate
  | string
  | RTCIceCandidateInit;

export interface PrimingDataInput extends MaybePrimingDataInput {
  timeout: number;
}

export const EMPTY_PROBE = Object.freeze({ hasProbed: false, probeUrls: [] });
export const EMPTY_ICE: IceCandidateStructure = Object.freeze({
  candidates: [],
  monitorData: undefined
});

// section Promise functions
export interface BasePromiseData {
  base: {
    doThrow: boolean;
    timeout: number;
  };
  iceCandidates?: PossibleIceCandidate[];
  getIceCandidates?: GetIceCandidatesFunction;
  config: ContentConfig;
  probe?: PingData;
  vals: DurationTimer;
  playGuid: string;
}
